import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

import image1 from "../img/utpl.png";

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="w-full bg-[#004270] shadow-md fixed top-0 left-0 z-50">
      <div className="max-w-6xl mx-auto px-4 min-h-[60px] flex justify-between items-center">
        
        {/* Logo */}
        <NavLink to="/" className="flex items-center shrink-0">
          <img
            src={image1}
            alt="UTPL"
            className="h-6 sm:h-8 md:h-8 w-auto object-contain"
          />
        </NavLink>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center gap-8 text-white">
          <a href="#inicio" className="hover:text-blue-200 transition">
            Inicio
          </a>

          <a href="#lineas" className="hover:text-blue-200 transition">
            Líneas temáticas
          </a>

          <a href="#inscripcion" className="hover:text-blue-200 transition">
            Inscripciones
          </a>

          <a
            href="#papers"
            className="bg-blue-600 text-white px-5 py-2 rounded-xl font-semibold hover:bg-blue-700 transition shadow-md"
          >
            Call for papers
          </a>
        </nav>

        {/* Mobile Button */}
        <button
          className="md:hidden text-white p-1"
          onClick={() => setOpen(!open)}
          aria-label="Abrir menú"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-[#004270] transition-all duration-300 overflow-hidden ${
          open ? "max-h-96 py-4" : "max-h-0"
        }`}
      >
        <div className="flex flex-col items-center gap-6 text-white">
          <a href="#inicio" onClick={() => setOpen(false)}>
            Inicio
          </a>

          <a href="#lineas" onClick={() => setOpen(false)}>
            Líneas temáticas
          </a>

          <a href="#inscripcion" onClick={() => setOpen(false)}>
            Inscripciones
          </a>

          <a
            href="#papers"
            onClick={() => setOpen(false)}
            className="bg-blue-600 text-white px-6 py-2 rounded-xl font-semibold shadow-md hover:bg-blue-700 transition"
          >
            Call for papers
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;